import { render } from "./wishlist.vue?vue&type=template&id=cb5ac6fe"
import script from "./wishlist.vue?vue&type=script&lang=js"
export * from "./wishlist.vue?vue&type=script&lang=js"

import "./wishlist.vue?vue&type=style&index=0&id=cb5ac6fe&lang=css"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__